<template>
  <div>
    <div class="section section-white content-padded">
      <div class="clearfix">
        <div class="f_l member-info">
          <div class="info-item">
            <span class="txt">怡贝会员ID</span>
            <span v-if="member.member_id">{{member.member_id}}</span>
            <span v-else>--</span>
          </div>
          <div class="info-item">
            <span class="txt">所属门店ID</span>
            <span v-if="member.store_id">{{member.store_id}}</span>
            <span v-else>--</span>
          </div>
          <div class="info-item">
            <span class="txt">怡康会员ID</span>
            <span v-if="member.user_id">{{member.user_id}}</span>
            <span v-else>--</span>
          </div>
<!--          <div class="info-item">-->
<!--            <span class="txt">会员等级</span>-->
<!--            <span v-if="member.member_lv_name">{{member.member_lv_name}}</span>-->
<!--            <span v-else>&#45;&#45;</span>-->
<!--          </div>-->
          <div class="info-item">
            <span class="txt">姓名</span>
<!--            <span v-if="member.name">{{member.name}}</span>-->
<!--            <span v-else>&#45;&#45;</span>-->
              <el-input v-model="member.name" style="width: 100px;" @change="changeName"></el-input>
          </div>
          <div class="info-item">
            <span class="txt">会员昵称</span>
            <span v-if="member.nickname">{{member.nickname}}</span>
            <span v-else>--</span>
          </div>
          <div class="info-item">
            <span class="txt">手机</span>
            <span v-if="member.mobile">{{member.mobile}}</span>
            <span v-else>--</span>
          </div>
          <div class="info-item">
            <span class="txt">注册IP</span>
            <span v-if="member.reg_ip">{{member.reg_ip}}</span>
            <span v-else>--</span>
          </div>
          <div class="info-item">
          <span class="txt">注册时间</span>
          <span v-if="member.regtime">{{member.regtime|datetime('yyyy-MM-dd hh:mm:ss')}}</span>
          <span v-else>--</span>
        </div>
        <el-form>
        <el-form-item label-width="68px" label="会员等级" style="padding: 0 28px 0 0;">
          <el-select v-model="member.member_lv_id" placeholder="请选择" @change="changeLv" style="height: 32px;width: 142px;">
            <el-option
              v-for="item in membersLv"
              :key="item.member_lv_id"
              :label="item.name"
              :value="parseInt(item.member_lv_id)">
            </el-option>
          </el-select>
        </el-form-item>
        </el-form>
        </div>
        <div class="f_r member-right">
          <div class="right-item point-box">
            <div class="item-title">账户余额</div>
            <div><span v-if="member.advance">{{member.advance}}</span><span v-else>0</span></div>
            <span class="item-footer"></span>
          </div>
          <div class="right-item point-box">
            <div class="item-title">累计资产</div>
            <div><span v-if="member.advance_accumulative">{{member.advance_accumulative}}</span><span v-else>0</span></div>
            <span class="item-footer"></span>
          </div>
          <div class="right-item point-box">
            <div class="item-title">优卡余额</div>
            <div><span v-if="member.benfit_money">{{member.benfit_money}}</span><span v-else>0</span></div>
            <span class="item-footer"></span>
          </div>
        </div>
      </div>
      <div class="content-center">
        <el-button type="primary" @click="goBack">返回</el-button>
      </div>
    </div>

    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
      <el-tab-pane label="提现记录" name="withdraw">
        <withdraw-list :user-id="member.member_id" :is-load="withdrawLoad"></withdraw-list>
      </el-tab-pane>
      <el-tab-pane label="订单记录" name="order">
        <order-list :user-id="member.member_id" :is-load="orderLoad"></order-list>
      </el-tab-pane>
      <el-tab-pane label="钱包明细" name="advance">
        <advance-list :user-id="member.member_id" :is-load="advanceLoad"></advance-list>
      </el-tab-pane>
      <el-tab-pane label="优卡钱包明细" name="benfitAdvance">
        <benfitAdvance-list :user-id="member.user_id" :is-load="benfitAdvanceLoad"></benfitAdvance-list>
      </el-tab-pane>
      <el-tab-pane label="分享点击统计" name="click">
        <click-list :user-id="member.member_id" :is-load="clickLoad"></click-list>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>
<script>
import {membersInfo, membersLvList, updateMembersInfo} from '../../../api/sharer'
import withdrawList from './withdrawlist.vue'
import orderList from './orderlist.vue'
import advanceList from './advancelist.vue'
import benfitAdvanceList from './benfitAdvancelist.vue'
import clickList from './clicklist.vue'
export default {
  components: {
    withdrawList,
    orderList,
    advanceList,
    benfitAdvanceList,
    clickList
  },
  data () {
    return {
      member_id: 0,
      currentPage: 1,
      member: {
        user_id: '',
        member_id: '',
        name: '',
        membersLv: ''
      },
      membersLv: '',
      activeName: 'withdraw',
      withdrawLoad: true,
      orderLoad: false,
      advanceLoad: false,
      benfitAdvanceLoad: false,
      clickLoad: false,
      registerSetting: ''
    }
  },
  methods: {
    getMember (filter) {
      membersInfo(filter).then(response => {
        // console.log(response)
        this.member = response.data.data
      })
    },
    getMembersLvList () {
      this.loading = true
      membersLvList().then(response => {
        // console.log(response)
        this.membersLv = response.data.data.list
      })
    },
    changeLv (val) {
      var msg = '此操作将会更改会员等级，是否继续?'
      this.$confirm( msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          'member_id': this.member.member_id,
          'member_lv_id': val
        }
        updateMembersInfo(params).then(res => {
          this.getMember({ member_id: this.member.member_id })
        })
      }).catch(()=> {
        console.log('取消操作')
        this.getMember({ member_id: this.member.member_id })
      })
    },
    changeName (val) {
      var msg = '此操作将会更改会员姓名，是否继续?'
      this.$confirm( msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          'member_id': this.member.member_id,
          'name': val
        }
        updateMembersInfo(params).then(res => {
          this.getMember({ member_id: this.member.member_id })
        })
      }).catch(()=> {
        console.log('取消操作')
        this.getMember({ member_id: this.member.member_id })
      })
    },
    handleClick () {
      switch (this.activeName) {
        case 'withdraw':
          this.withdrawLoad = true
          this.orderLoad = false
          this.advanceLoad = false
          this.benfitAdvanceLoad = false
          this.clickLoad = false
          break
        case 'order':
          this.orderLoad = true
          this.withdrawLoad = false
          this.advanceLoad = false
          this.benfitAdvanceLoad = false
          this.clickLoad = false
          break
        case 'advance':
          this.advanceLoad = true
          this.benfitAdvanceLoad = false
          this.orderLoad = false
          this.withdrawLoad = false
          this.clickLoad = false
          break
        case 'benfitAdvance':
          this.benfitAdvanceLoad = true
          this.advanceLoad = false
          this.orderLoad = false
          this.withdrawLoad = false
          this.clickLoad = false
          break
        case 'click':
          this.clickLoad = true
          this.advanceLoad = false
          this.benfitAdvanceLoad = false
          this.orderLoad = false
          this.withdrawLoad = false
          break
      }
    },
    goBack () {
      this.$router.go(-1)
    }
  },
  mounted () {
    if (this.$route.query.member_id) {
      this.member_id = this.$route.query.member_id
    }
    if (this.$route.query.currentPage) {
      this.currentPage = this.$route.query.currentPage
    }
    this.getMember({ member_id: this.member_id })
    this.getMembersLvList()
  }
}
</script>
<style scoped lang="scss">
.member-card-box {
  margin-right: 20px;
  .member-card {
    padding: 25px;
    width: 330px;
    height: 200px;
    border-radius: 5px;
    color: #fff;
    text-align: center;
    img.member-header {
      display: block;
      width: 70px;
      height: 70px;
      border-radius: 50%;
      margin: 0 auto 10px;
      border: 2px solid #fff;
    }
    img.icon {
      width: 22px;
      height: 22px;
      vertical-align: bottom;
      margin-left: 5px;
    }
    .level-txt {
      display: inline-block;
      margin: 10px auto 0;
      background: #ff5000;
      color: #fff;
      padding: 2px 8px;
      border: 1px solid #fff;
      border-radius: 25px;
    }
  }
}
.member-info {
  .info-item {
    margin: 5px 0;
    .txt {
      display: inline-block;
      width: 80px;
    }
  }
}
.member-right {
  position: relative;
  text-align: center;
  top: -15px;
  margin-right: 5%;
  .right-item {
    position: relative;
    display: inline-block;
    text-align: center;
    width: 105px;
    color: #fff;
    margin: 0 5px;
    line-height: 2;
    padding: 50px 10px 60px;
    overflow: hidden;
    .item-title {
      font-size: 16px;
    }
    &::after {
      content: '';
      position: absolute;
      background: #fff;
      width: 120px;
      height: 80px;
      border-radius: 50%;
      left: 50%;
      bottom: -60px;
      transform: translateX(-50%);
    }
    &:nth-child(1) {
      background: #409EFF;
    }
    &:nth-child(2) {
      background: #ff5000;
    }
    &:nth-child(3) {
      background: #7600ff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// detail.vue?ca126a0e